var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0H1C0.447 0 0 0.447 0 1V3.59C0 4.113 0.213 4.627 0.583 4.997L6 10.414V18C6 18.347 6.18 18.668 6.475 18.851C6.635 18.95 6.817 19 7 19C7.153 19 7.306 18.965 7.447 18.895L11.447 16.895C11.786 16.725 12 16.379 12 16V10.414L17.417 4.997C17.787 4.627 18 4.113 18 3.59V1C18 0.447 17.553 0 17 0ZM10.293 9.293C10.105 9.48 10 9.734 10 10V15.382L8 16.382V10C8 9.734 7.895 9.48 7.707 9.293L2 3.59V2H16.001L16.003 3.583L10.293 9.293Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.3c412797700a309e4216ec9c59410120.svg";
export { ForwardRef as ReactComponent };